
import axios from 'axios';

import {
  defineComponent,
  ref,
  reactive,
  onMounted,
} from 'vue';

import type {
  ErrorsMap,
  QualityPreset,
} from '@/types';

import {
  ENTRIES_SORT_BY_DIRECTION_ASC,
  QUALITY_PRESET_COMPARATORS,
} from '@/libs/consts';

import useUser from '@/composable/useUser';

import useEntries from '@/composable/useEntries';

export default defineComponent({
  setup() {
    const { activeUser: user } = useUser();

    const { getEntryByRoute } = useEntries();

    const {
      entriesLoading: projectsLoading,
      entries: projects,
      fetchEntries: fetchProjects,
    } = useEntries();

    const {
      entriesLoading: endpointsLoading,
      entries: endpoints,
      fetchEntries: fetchEndpoints,
    } = useEntries();

    const qualityPreset = reactive<QualityPreset>({
      endpoints_ids: [],
      public: true,
      ...Object.fromEntries(QUALITY_PRESET_COMPARATORS.map((attribute: string) => [attribute, null])),
    } as unknown as QualityPreset);

    const qualityPresetErrorsMap = ref<ErrorsMap>({});

    const fetchEndpointsWrapper = async (): Promise<void> => fetchEndpoints(
      '/api/endpoint/getEndpoints',
      {
        project_id: user.isSuperAdmin() ? qualityPreset.project_id : undefined,
        sort_by: 'status',
        sort_by_direction: ENTRIES_SORT_BY_DIRECTION_ASC,
      },
    );

    const fetchQualityPreset = async (): Promise<void> => {
      const entry = await getEntryByRoute('/api/quality-preset/getQualityPresetById');

      if (entry) {
        Object.assign(qualityPreset, entry);
      }

      fetchEndpointsWrapper();
    };

    const storeQualityPreset = async (): Promise<void> => {
      const response = await axios.post('/api/quality-preset/storeQualityPreset', qualityPreset);

      Object.assign(qualityPreset, response.data);
    };

    const onProjectChange = (): void => {
      qualityPreset.endpoints_ids = [];

      fetchEndpointsWrapper();
    };

    onMounted((): void => {
      Promise.all([
        user.isSuperAdmin() ? fetchProjects('/api/project/getProjects') : Promise.resolve(),
      ]);
    });

    return {
      QUALITY_PRESET_COMPARATORS,
      user,
      projectsLoading,
      projects,
      endpointsLoading,
      endpoints,
      qualityPreset,
      qualityPresetErrorsMap,
      fetchQualityPreset,
      storeQualityPreset,
      onProjectChange,
    };
  },
});
